import React, { useState } from "react";
import "./ProductOptions.scss";

const ProductOptions = ({ options = [], onOptionChange, onPriceChange }) => {
    const [selectedOptions, setSelectedOptions] = useState({});
    const [totalPriceDelta, setTotalPriceDelta] = useState(0);

    // 옵션 선택 핸들러
    const handleOptionSelect = (groupId, valueId, priceDelta, value) => {
        try {
            const newSelectedOptions = {
                ...selectedOptions,
                [groupId]: {
                    valueId,
                    priceDelta: Number(priceDelta) || 0,
                    value: value,
                },
            };

            setSelectedOptions(newSelectedOptions);

            // 총 가격 변동 계산
            const newTotalPriceDelta = Object.values(newSelectedOptions).reduce(
                (sum, option) => sum + (option.priceDelta || 0),
                0
            );

            setTotalPriceDelta(newTotalPriceDelta);

            // 부모 컴포넌트에 변경사항 전달
            if (typeof onOptionChange === "function") {
                onOptionChange(newSelectedOptions);
            }
            if (typeof onPriceChange === "function") {
                onPriceChange(newTotalPriceDelta);
            }
        } catch (error) {
            console.error("옵션 선택 중 에러 발생:", error);
        }
    };

    // 선택된 옵션 값 가져오기
    const getSelectedValue = (groupId) => {
        return selectedOptions[groupId]?.valueId || "";
    };

    // 모든 필수 옵션이 선택되었는지 확인
    const isAllOptionsSelected = () => {
        return options.every((group) => selectedOptions[group.id]);
    };

    if (!options || options.length === 0) {
        return null;
    }

    return (
        <div className="product-options-wrap">
            <div className="options-title">
                {totalPriceDelta !== 0 && (
                    <span className="price-delta">
                        {totalPriceDelta > 0 ? "+" : ""}
                        {totalPriceDelta.toLocaleString()}원
                    </span>
                )}
            </div>

            {options.map((group) => (
                <div key={group.id} className="option-group">
                    <label className="option-group-label">
                        {group.group_name}
                    </label>

                    <div className="option-values">
                        {group.values
                            .filter((value) => value.is_active)
                            .sort((a, b) => a.order - b.order)
                            .map((value) => (
                                <button
                                    key={value.id}
                                    type="button"
                                    className={`option-value-btn ${
                                        getSelectedValue(group.id) === value.id
                                            ? "selected"
                                            : ""
                                    }`}
                                    onClick={() =>
                                        handleOptionSelect(
                                            group.id,
                                            value.id,
                                            value.price_delta,
                                            value.value
                                        )
                                    }
                                    aria-pressed={
                                        getSelectedValue(group.id) === value.id
                                    }
                                >
                                    <span className="value-name">
                                        {value.value}
                                    </span>
                                    {Number(value.price_delta) !== 0 && (
                                        <span className="value-price">
                                            {Number(value.price_delta) > 0
                                                ? "+"
                                                : ""}
                                            {Number(
                                                value.price_delta
                                            ).toLocaleString()}
                                            원
                                        </span>
                                    )}
                                </button>
                            ))}
                    </div>
                </div>
            ))}

            {!isAllOptionsSelected() && (
                <div className="option-warning">
                    <span>모든 옵션을 선택해주세요.</span>
                </div>
            )}
        </div>
    );
};

export default ProductOptions;
